'use client';

import { PlanUpgradeProvider } from 'src/contexts/plan-upgrade-context';

import { useAuthContext } from 'src/auth/hooks';

export type PlanUpgradeRootProps = {
  children: React.ReactNode;
};

/**
 * AuthProvider 하위에서 전역 PlanUpgrade context 제공
 * (서비스 AuthGuard 밖: MainLayout AccountDrawer 등)
 */
export function PlanUpgradeRoot({ children }: PlanUpgradeRootProps) {
  const { user } = useAuthContext();

  return (
    <PlanUpgradeProvider user={user}>
      {children}
    </PlanUpgradeProvider>
  );
}
